import { instantStatisticRequired } from '../../../../kinds/poll/questions/schemaFields';
import { createBaseQuestionSchema, questionText } from '../schemaFields';
import { config } from './TextareaPoll.config';

export const schema = createBaseQuestionSchema({
  type: { enum: [config.name] },
  ...questionText,
  ...instantStatisticRequired,
});
